import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { Store } from 'store/storeTypes';
import { openHolidaysModal } from 'actions/holidaysActions';
import { getProductionHoursHolidaysRequest } from 'actions/productionHoursApiActions';
import { selectHolidaysSummaryForSite } from './holidaysSelectors';
import HolidaysCard from './components/HolidaysCard';

type OwnProps = { siteNames: string[] };

const mapStateToProps = (state: Store, ownProps: OwnProps) => ({
  summaries: ownProps.siteNames.map(name => ({
    siteName: name,
    summary: selectHolidaysSummaryForSite(state, name),
  })),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    { onOpen: openHolidaysModal, onFetchHolidays: getProductionHoursHolidaysRequest },
    dispatch
  );

export type HolidaysCardProps = OwnProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(HolidaysCard);
